import { module } from 'modujs';
import { default as lottie } from 'lottie-web';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
		
		this.delay = typeof this.getData('delay') == 'string' ? parseInt(this.getData('delay')) : 0;

		this.lottie = lottie.loadAnimation({
			container: this.el, // the dom element that will contain the animation
			renderer: window.isMobile ? 'canvas' : 'canvas',
			loop: false,
			autoplay: false,
			path: this.getData('file') // the path to the animation json
		});

		this.keyframe = typeof this.getData('keyframe') == 'string' ? parseInt(this.getData('keyframe')) : 0;

		if(window.isMobile) {
			this.lottie.goToAndStop(this.keyframe,true)
		} else {
			this.bindComplete = this.complete.bind(this);
			this.lottie.addEventListener('complete',this.bindComplete);
		}

    }

	complete() {
		gsap.delayedCall(this.delay, () => {
			this.lottie.goToAndPlay(0);
		})
	}

	trigger(e) {
		if(!window.isMobile) {
			if(e.mode == 'enter') {
				this.lottie.play();
			} else {
				this.lottie.pause();
			}
		}
	}

	destroy() {
		if(!window.isMobile) {
			this.lottie.removeEventListener('complete',this.bindComplete);
		}
	}
}
